import {http_client} from '@/plugins/http_client';
const listarIngresos = async (params) => await http_client(`/api/configuraciones-adicionales/ingresos`, params, 'get');
const catalogoIngresos = async (params) => await http_client(`api/configuraciones-adicionales/ingresos/param`, params, 'get');
const crearIngreso = async (body) => await http_client(`/api/configuraciones-adicionales/ingreso`, body, 'post');
const editarIngreso = async (id, body) => await http_client(`/api/configuraciones-adicionales/ingreso/${id}`, body, 'put');
const cambiarEstadoIngreso = async (id) => await http_client(`/api/configuraciones-adicionales/ingreso/${id}/estado`, {}, 'put');
const historicoIngreso = async (id) => await http_client(`/api/configuraciones-adicionales/ingreso/${id}/historial`, {}, 'get');
const catalogoUnidad = async (params) => await http_client(`/api/configuraciones-adicionales/unidades`, params, 'get');
const catalogoSistema = async (params) => await http_client(`/api/configuraciones-adicionales/sistemas-pago`, params, 'get');
const catalogoEspecificoGasto = async (params) => await http_client(`/api/configuraciones-adicionales/especificos-gasto`, params, 'get');
const catalogoCalculo = async (params) => await http_client(`/api/configuraciones-adicionales/formas-calculo`, params, 'get');
const listarEmpleados = async (params) => await http_client(`/api/configuraciones-adicionales/empleados`, params, 'get');
const listarEmpleadosAsignados = async (id, params) => await http_client(`/api/configuraciones-adicionales/ingreso/${id}/empleados`, params, 'get');
const detalleEmpleado = async (id) => await http_client(`/api/configuraciones-adicionales/empleado/${id}`, {}, 'get');
const asignarEmpleados = async (id, body) => await http_client(`/api/configuraciones-adicionales/ingreso/${id}/empleados`, body, 'post');
const removerEmpleados = async (id, body) => await http_client(`/api/configuraciones-adicionales/ingreso/${id}/empleados`, body, 'delete');
const editarMontoAplicado = async (id, body) => await http_client(`/api/configuraciones-adicionales/ingreso/${id}/empleado`, body, 'put');

export default {
    listarIngresos,
    catalogoIngresos,
    crearIngreso,
    editarIngreso,
    cambiarEstadoIngreso,
    historicoIngreso,
    catalogoUnidad,
    catalogoSistema,
    catalogoEspecificoGasto,
    catalogoCalculo,
    listarEmpleados,
    listarEmpleadosAsignados,
    detalleEmpleado,
    asignarEmpleados,
    removerEmpleados,
    editarMontoAplicado
}